import { useState, useEffect, useCallback, useContext } from 'react';
import useDebounce from '#/useDebounce';
import SearchContext from '^/SearchContext';

const SearchBar = (props) => {

  const {
    setShow

  } = props;

  const {
    handleSearchAPI,
    setSearchResults,
    handleSearch,
    search,
    setSearch,
  } = useContext(SearchContext);


  const { debounceFn } = useDebounce(handleSearch, [search]);


  useEffect(() => {
    debounceFn(search);
  }, [search])

  return (
    <form
      onSubmit={(e) => {
        // e.preventDefault();
        // window.location.href = '/products?search_query=' + search
      }}
      action={"/products?search_query=" + search}
      method="GET"
    >

      <input type="text"
        value={search}

        onFocus={() => setShow(true)}
        onChange={e => setSearch(e.target.value.replaceAll('\'', ''))}
        className="search-small w-input" maxLength="256" name="search_query" 
        placeholder="Search Store..." 
        id="search_query" />
      {/* <input
        className='hide'
        type='submit'
      /> */}
    </form>
  )
}

export default SearchBar;